import React from "react";
import $ from "jquery";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import * as GC from "../../../../common/common";

class CreateBudget extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            naam: "",
            naamRequiredAlert: false,
            code: GC.CodeAutoFill("BU"),
            codeRequiredAlert: false,
            jaar: "",
            jaarRequiredAlert: false,
            tarief: "geen",
            tariefRequiredAlert: false,
            bedrag: "",
            bedragRequiredAlert: false,
            active: true,
            requiredList: [
                {name: "naam", alertState: "naamRequiredAlert"},
                {name: "code", alertState: "codeRequiredAlert"},
                {name: "jaar", alertState: "jaarRequiredAlert"},
                {name: "tarief", alertState: "tariefRequiredAlert"},
                {name: "bedrag", alertState: "bedragRequiredAlert"},
            ],
        };
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value,
        });

        this.state.requiredList.forEach((item) => {
            if (value != "" && name == item.name) {
                this.setState({[item.alertState]: false});
            }
        });
    }

    async handleSubmit() {
        var that = this;
        $("#cover-spin").show(0);

        var model = {
            relationships: {definition: {code: "BUDGETTEN"}},
            content: {
                algemeen: {
                    btwtarief: this.state.tarief,
                    actief: this.state.active,
                    bedrag: this.state.bedrag,
                    naam: this.state.naam,
                    code: this.state.code,
                    jaar: this.state.jaar,
                },
            },
        };

        this.state.naam == ""
            ? await this.setState({naamRequiredAlert: true})
            : await this.setState({naamRequiredAlert: false});
        this.state.code == ""
            ? await this.setState({codeRequiredAlert: true})
            : await this.setState({codeRequiredAlert: false});
        this.state.jaar == ""
            ? await this.setState({jaarRequiredAlert: true})
            : await this.setState({jaarRequiredAlert: false});
        this.state.tarief == ""
            ? await this.setState({tariefRequiredAlert: true})
            : await this.setState({tariefRequiredAlert: false});
        this.state.bedrag == ""
            ? await this.setState({bedragRequiredAlert: true})
            : await this.setState({bedragRequiredAlert: false});

        let isUnique = true;
        let uniqueModel = {
            content: [
                {
                    and_or: "AND",
                    datatype: "STRING",
                    key: "algemeen-code",
                    values: [this.state.code],
                },
            ],
            definitions: [process.env.REACT_APP_CATALOG_BUDGET],
            sorting: [],
        };

        //** code isunique control.
        await omnimap
            .FillTableAction(uniqueModel, 1, window.$catalog_management_units_token)
            .then((result) => {
                if (result.data && result.data.length > 0) {
                    isUnique = false;
                    this.setState({
                        codeRequiredAlert: true,
                        codeAlertText: "is not unique",
                    });
                }
            });

        if (
            this.state.naamRequiredAlert !== true &&
            this.state.codeRequiredAlert !== true &&
            this.state.jaarRequiredAlert !== true &&
            this.state.tariefRequiredAlert !== true &&
            this.state.bedragRequiredAlert !== true &&
            isUnique === true
        ) {
            omnimap
                .SaveOrEditAction(
                    model,
                    "POST",
                    "",
                    window.$catalog_management_units_token
                )
                .then((data) => {
                    CallBackFunctions.budgetSavedCallBack(
                        window.$catalog_management_units_token
                    );
                    // Clear state
                    this.setState(this.state.initialState)
                    this.setState({
                        code: GC.CodeAutoFill("BU")
                    })
                })
                .catch((error) => {
                    console.log(error);
                });
        } else {
            $("#cover-spin").hide(0);
        }
    }

    async componentDidMount() {
        this.setState({
            'initialState': Object.assign({}, this.state)
        })

        $(document).on("click", "#create_budget", function () {
            $("#create_budget_modal").modal("show");
        });
    }

    render() {
        return (
            <div
                className="modal fade"
                tabIndex={-1}
                role="dialog"
                id="create_budget_modal"
            >
                <div className="modal-dialog" role="document" >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Nieuw Budget</h5>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body" style={{minHeight:'520px'}}
                        >
                            <label
                                className={
                                    this.state.naamRequiredAlert
                                        ? "modale-submit-alert-block"
                                        : ""
                                }
                            >
                                Naam *
                            </label>{" "}
                            <label
                                className={
                                    this.state.naamRequiredAlert
                                        ? "modale-submit-alert-block"
                                        : "modale-submit-alert-none"
                                }
                            >
                                {"\u00A0"} required
                            </label>
                            <input
                                type="input"
                                className="form-control"
                                placeholder="Naam"
                                autocomplete="off"
                                name="naam"
                                value={this.state.naam}
                                onChange={this.handleInputChange}
                            />
                            <br/>
                            <label
                                className={
                                    this.state.codeRequiredAlert
                                        ? "modale-submit-alert-block"
                                        : ""
                                }
                            >
                                Code *
                            </label>{" "}
                            <label
                                className={
                                    this.state.codeRequiredAlert
                                        ? "modale-submit-alert-block"
                                        : "modale-submit-alert-none"
                                }
                            >
                                {"\u00A0"} required
                            </label>
                            <input
                                type="input"
                                className="form-control"
                                placeholder="Code"
                                name="code"
                                autocomplete="off"
                                value={this.state.code}
                                onChange={this.handleInputChange}
                            />
                            <br/>
                            <label
                                className={
                                    this.state.jaarRequiredAlert
                                        ? "modale-submit-alert-block"
                                        : ""
                                }
                            >
                                Jaar *
                            </label>{" "}
                            <label
                                className={
                                    this.state.jaarRequiredAlert
                                        ? "modale-submit-alert-block"
                                        : "modale-submit-alert-none"
                                }
                            >
                                {"\u00A0"} required
                            </label>
                            <input
                                type="number"
                                className="form-control"
                                name="jaar"
                                value={this.state.jaar}
                                onChange={this.handleInputChange}
                            />
                            <br/>
                            <label
                                className={
                                    this.state.tariefRequiredAlert
                                        ? "modale-submit-alert-block"
                                        : ""
                                }
                            >
                                BTW tarief *
                            </label>{" "}
                            <label
                                className={
                                    this.state.tariefRequiredAlert
                                        ? "modale-submit-alert-block"
                                        : "modale-submit-alert-none"
                                }
                            >
                                {"\u00A0"} required
                            </label>
                            <select
                                class="form-control"
                                name="btwPercentage"
                                value={this.state.tarief}
                                onChange={this.handleInputChange}
                            >
                                <option selected={true} value="geen">
                                    geen
                                </option>
                                <option value="laag">laag</option>
                                <option value="hoog">hoog</option>
                            </select>
                            <br/>
                            <label
                                className={
                                    this.state.bedragRequiredAlert
                                        ? "modale-submit-alert-block"
                                        : ""
                                }
                            >
                                Bedrag excl. BTW *
                            </label>{" "}
                            <label
                                className={
                                    this.state.bedragRequiredAlert
                                        ? "modale-submit-alert-block"
                                        : "modale-submit-alert-none"
                                }
                            >
                                {"\u00A0"} required
                            </label>
                            <input
                                type="number"
                                className="form-control"
                                name="bedrag"
                                value={this.state.bedrag}
                                onChange={this.handleInputChange}
                            />
                            <label>Actief</label>
                            <label className="switch">
                                <input
                                    type="checkbox"
                                    defaultChecked
                                    name="active"
                                    value={this.state.active}
                                    onChange={this.handleInputChange}
                                />
                                <span className="slider-checkbox round"/>
                            </label>
                            <br/>
                            <br/>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn-modal"
                                onClick={this.handleSubmit.bind(this)}
                            >
                                Verwerken
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CreateBudget;
